import { Box, Button } from "@mui/material";
import { useState } from "react";
import { useImpressions } from "../../service/useImpressions";
import ImagesList from "../imageGallery/imagesList";
import Impressions from "./impressions";
import BackLoading from "../loading/backLoading";
import { downloadImage } from "../../page/Admin/magasin/PageCommandTraiteParcode";
import EditImagePopup from "../EditImage";
import ImprimantSucces from "../message/imprimanteSucces";
import { GetImageParCommand } from "../../store/slice/CommandDahbordSlice";
import CategoryHashTags from "../hashtags/categoryHashtagsSelected";
import CircularProgress from "@mui/material/CircularProgress";
import { ConfirmPrintPopup } from "../Popup/confirmationImpression";
function ImageImpression({ images, data, displayEdit = true }) {
  const {
    allImages,
    selectedImages,
    openCropper,
    demonsion,
    src,
    loading,
    openPopup,
    handleSelectImage,
    handleSelectAll,
    editCountImage,
    sendToPrint,
    editImage, // Function to edit the image after cropping
    openImageCropper, // Opens the crop dialog for a specific image
    setOpenCropper,
    setOpenPopup,
    selectedCategories,
    setSelectedCategories,
    sendNewhastags,
    PopupCat,
    setPopupCat,
    NumberImpression,
    text,
    setText,
    background,
    setBackground,
  } = useImpressions(images, data?.id, data?.imprimant);
  const [popupConfirm, setPopupConfirm] = useState(false);
  console.log("images in image impression", images);
  console.log("data in image impression", data);
  console.log("allImages in image impression", allImages);
  return (
    <Box>
      <Impressions
        allImages={allImages}
        selectedImages={selectedImages}
        handleSelectImage={handleSelectImage}
        downloadImage={downloadImage}
        editImage={editImage}
        openImageCropper={openImageCropper}
        editCountImage={editCountImage}
        displayEdit={displayEdit}
      />
      <Button variant="contained" onClick={sendToPrint}>
        imprime
      </Button>
      <EditImagePopup
        open={openCropper}
        onClose={() => setOpenCropper(false)}
        src={src}
        demonsion={demonsion}
        onSubmit={editImage}
        text={text}
        setText={setText}
        background={background}
        setBackground={setBackground}
        backgrounds={[]}
      />
      <CategoryHashTags
        open={PopupCat}
        onClose={() => setPopupCat(false)}
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        sendNewhastags={sendNewhastags}
      />
      <ConfirmPrintPopup
        open={popupConfirm}
        onClose={() => setPopupConfirm(false)}
        onConfirm={() => {
          sendToPrint();
          setPopupConfirm(false);
        }}
      />
      <BackLoading open={loading} />
      <ImprimantSucces open={openPopup} onClose={() => setOpenPopup(false)} />
    </Box>
  );
}

export default ImageImpression;
